// Payment code returned by /payment-methods/extra-info and used at checkout.
export const EMKAN_CODE = "emkan_bnpl";
export const EMKAN_LOGO_SRC = "/imgs/emkan/emkan-logo.svg";
